import React from 'react';
import styles from './StepDialogFooter.module.css';

interface StepDialogFooterProps {
  onCancel: () => void;
  onOK: () => void;
}

export const StepDialogFooter: React.FC<StepDialogFooterProps> = ({
  onCancel,
  onOK,
}) => {
  return (
    <footer className={styles.footer}>
      <button
        onClick={onCancel}
        className={`${styles.button} ${styles.buttonCancel}`}>
        Cancel
      </button>
      <button
        onClick={onOK}
        className={`${styles.button} ${styles.buttonPrimary}`}>
        OK
      </button>
    </footer>
  );
};
